// import { AnyObj } from "./types";

// MP 类型：FMP | RMP
export type MPType = 'first' | 'route'
/**
 * MP 上报信息
 */
export interface MPInfo {
  type: MPType;
  // mp 开始时间
  mpStartTime: number;
  // mp 结束时间
  mpEndTime: number;
  /* 路由渲染耗时 */
  rmpCostTime?: number;
  // 当前路由地址
  url?: string;
  // mp 是否是中断结束
  interrupt?: boolean;
  // mp 计算是否是超时
  timeout?: boolean;
  doms?: string;
  rangeTop?: number;
  rangeBottom?: number;
  rangeLeft?: number;
  rangeRight?: number;
}

export interface DOMInfo {
  insertTime: number;
  tagName: string;
  tagClassName?: string;
  tagWeId?: string;
  tagId?: string;
  top: number;
  left: number;
  bottom: number;
  right: number;
}

export interface MPCallback {
  (mpInfo: MPInfo): void;
}

export interface MPOption {
  // MP 类型：FMP | RMP
  type?: MPType;
  // MP 时间回调
  callback?: MPCallback;
}

const MPInterval = 2000; // 定时检测 dom 变化的时间间隔
const MPIntervalMax = 60000; // 定时检测 dom 变化的最长监听时间

class MeaningfulPaint {
  // MP 类型
  type: MPType;
  // dom 渲染监听器
  timmer: any;
  // dom 是否还在渲染
  padding: boolean = false;
  // MP 计算超时
  timeout: boolean = false;
  // dom 开始渲染时间
  start: number = 0;
  // dom 渲染完成时间
  end: number = 0;
  // 当前地址
  url: string = '';
  // dom 数据
  doms: DOMInfo[] = [];
  // 主要显示区域
  rangeT: number = 0;
  rangeB: number = 0;
  rangeL: number = 0;
  rangeR: number = 0;
  // 主要内容完成渲染回调
  callback: MPCallback | undefined;

  constructor(option: MPOption = {}) {
    this.type = option.type || 'first';
    this.callback = option.callback;
  }

  startTrack = () => {
    this.reset();
    this.padding = true;
    this.start = Date.now();
    if (this.type === 'route') {
      this.url = window?.location?.href;
    }
    this.initRange();
    // 非计算 FMP 时间，需要开启定时器
    if (this.type !== 'first') {
      if (this.timmer) clearInterval(this.timmer);
      this.timmer = setInterval(() => {
        const now = Date.now();
        // 如果主要显示区域 1s 以内都没有变化了，说明主要显示区域已经加载完成
        if (this.padding && this.end && this.start && (now - this.end > MPInterval)) {
          this.stopTrace();
        }
        // 如果 MP 计算总共运行超过了 1min 也算加载完成
        if (!this.padding || (now - this.start > MPIntervalMax)) {
          this.timeout = true;
          this.stopTrace(true);
        }
      }, MPInterval);
    }
    // document?.addEventListener('DOMNodeInserted', this.onDOMNodeInserted);
  }

  stopTrace = (interrupt: boolean = false) => {
    if (this.padding) {
      if (interrupt) {
        this.end = Date.now();
      }
      let mpInfo: MPInfo = {
        type: this.type,
        mpStartTime: this.start,
        mpEndTime: this.end,
        timeout: this.timeout,
        interrupt,
      };
      if (this.type === 'route') {
        try {
          mpInfo = {
            ...mpInfo,
            rmpCostTime: mpInfo.mpEndTime - mpInfo.mpStartTime,
            url: this.url,
            doms: JSON.stringify(this.doms),
            rangeTop: this.rangeT,
            rangeBottom: this.rangeB,
            rangeLeft: this.rangeL,
            rangeRight: this.rangeR,
          };
        } catch (e) {}
      }
      this.callback?.(mpInfo);
    }
    this.reset();
  }

  // 初始化显示区域的范围
  initRange = () => {
    // 上下 10% 左右 15%
    this.rangeT = document.documentElement.clientHeight * 0.1;
    this.rangeB = document.documentElement.clientHeight * 0.85;
    this.rangeL = document.documentElement.clientWidth * 0.1;
    this.rangeR = document.documentElement.clientWidth * 0.85;
  }

  // 检测是否在显示区域
  checkRange = ({ top, left, bottom, right }: { top: number, left: number, bottom: number, right: number}) => {
    const checkTop = top > this.rangeT && top < this.rangeB ? 1 : 0;
    const checkBottom = bottom > this.rangeT && bottom < this.rangeB ? 1 : 0;
    const checkLeft = left > this.rangeL && left < this.rangeR ? 1 : 0;
    const checkRight = right > this.rangeT && right < this.rangeB ? 1 : 0;
    // 如果任意两边在内容区域都算做是有效
    return (checkTop + checkBottom + checkLeft + checkRight) > 1;
  }

  // 监听 dom 节点插入时，校验插入的节点是否在主要显示区域
  onDOMNodeInserted = (e: Event) => {
    if (this.padding && e.target && (e.target as Element).getBoundingClientRect) {
      if (!this.start) { this.start = Date.now() };
      const target = e.target as Element;
      const { top, left, bottom, right } = target.getBoundingClientRect();
      if (this.checkRange({ top, left, bottom, right })) {
        this.end = Date.now();
        this.doms.push({
          insertTime: this.end,
          tagName: target.tagName,
          tagWeId: (target as any).weId || '',
          tagId: target.id,
          tagClassName: typeof target.className === 'string' ? target.className : '',
          top, left, bottom, right,
        });
        // 检测到第一个符合条件的 dom 就算作完成
        if (this.type === 'first') {
          this.stopTrace();
        }
      }
    }
  }

  reset = () => {
    // dom 渲染监听器
    if (this.timmer) clearInterval(this.timmer);
    // dom 是否还在渲染
    this.padding = false;
    // 重置 timeout
    this.timeout = false;
    // dom 开始渲染时间
    this.start = 0;
    // dom 渲染完成时间
    this.end = 0;
    // dom 插入节点
    this.doms = [];
    // 主要显示区域
    this.rangeT = 0;
    this.rangeB = 0;
    this.rangeL = 0;
    this.rangeR = 0;
  }
}

export default MeaningfulPaint;
